// Locked school pricing tiers for the client (the Admin quote form and the accept
// page display). Mirror of netlify/lib/tiers.mjs — keep the two in sync.

export interface Tier { key: string; max: number; label: string; price: number; seats: number; }

export const TIERS: Tier[] = [
  { key: 'tier1', max: 300, label: 'Up to 300 students', price: 6000, seats: 20 },
  { key: 'tier2', max: 600, label: 'Up to 600 students', price: 12000, seats: 40 },
  { key: 'tier3', max: 900, label: 'Up to 900 students', price: 18000, seats: 60 },
  { key: 'tier4', max: 1200, label: 'Up to 1,200 students', price: 24000, seats: 80 },
];

export const formatPrice = (dollars: number): string => '$' + Number(dollars).toLocaleString('en-US');

export type TierResult = Tier | { key: 'over'; contactSean: true } | null;

// Map a student count (number or a string like "Up to 600" / "More than 1,200")
// to a tier. Over 1,200 returns { contactSean: true }; unreadable returns null.
export function selectTier(studentCount: string | number | null | undefined): TierResult {
  const s = String(studentCount == null ? '' : studentCount).toLowerCase();
  if (/more than|over|1,?200\s*\+/.test(s)) return { key: 'over', contactSean: true };
  const digits = s.replace(/[^0-9]/g, '');
  if (!digits) return null;
  const n = parseInt(digits, 10);
  if (!Number.isFinite(n) || n <= 0) return null;
  if (n > 1200) return { key: 'over', contactSean: true };
  for (const t of TIERS) if (n <= t.max) return { ...t };
  return { key: 'over', contactSean: true };
}
